module.exports = __webpack_public_path__ + "img/一体化背景.2fa0c262.png";